/**
 * @typedef {'xs'|'sm'|'md'|'lg'|'xl'} Viewport
 * @typedef {{ xs?: *, sm?: *, md?: *, lg?: *, xl?: * }} ViewportPartial
 * @typedef {{ xs: *, sm: *, md: *, lg: *, xl: * }} ViewportSet
 */

const viewports = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl'
};
viewports.map = new Map([[viewports.xs, 0], [viewports.sm, 576], [viewports.md, 768], [viewports.lg, 992], [viewports.xl, 1200]]);
viewports.values = Array.from(viewports.map.values());
viewports.keys = Array.from(viewports.map.keys());
const viewportsSortedDescending = Array.from(viewports.map.entries()).reverse();

// The largest viewport such that the given width is still >= the breakpoint
viewports.select = (width = 0) => {
  if (!Number.isFinite(+width) || width < 0) {
    throw new Error(`width must be a non-negative number, received: ${width}`);
  }
  return viewportsSortedDescending.find(([, min]) => width >= min)[0];
};

/**
 * Turns an incomplete object keyed by viewports into a more-complete one, filling in gaps
 * from smallest to largest like media query breakpoints do. For example,
 * viewports.inherit({ sm: 2, lg: 4 }) returns { xs: undefined, sm: 2, md: 2, lg: 4, xl: 4 }
 *
 * @param {ViewportPartial} viewports
 * @returns {ViewportSet}
 */
const inherit = ({
  xs,
  sm = xs,
  md = sm,
  lg = md,
  xl = lg
}) => ({
  xs,
  sm,
  md,
  lg,
  xl
});
viewports.inherit = inherit;

/**
 * Turns an array of viewports values from smallest to largest into an explicitly keyed object, e.g.
 * viewports.fromArray([1,2,,3,4]) returns { xs: 1, sm: 2, md: undefined, lg: 3, xl: 4 }
 *
 * @param {[*,*,*,*,*]} viewports
 * @returns {ViewportSet}
 */
const fromArray = viewportsArray => ({
  xs: viewportsArray[0],
  sm: viewportsArray[1],
  md: viewportsArray[2],
  lg: viewportsArray[3],
  xl: viewportsArray[4]
});
viewports.fromArray = fromArray;
export default viewports;